import { ZyNodeViewWrapper } from '@/components/common/node-view-wrapper';
import { NodeViewContent, type ReactNodeViewProps } from '@tiptap/react';

export function ZyDEInstructionNodeView({ decorations }: ReactNodeViewProps) {
    return (
        <ZyNodeViewWrapper decorations={decorations}>
            <div className="rounded border border-gray-300 bg-white p-3 overflow-auto m-4">
                <div
                    contentEditable={false}
                    className="mb-2 text-sm font-semibold text-gray-700"
                >
                    Instructions
                </div>
                <NodeViewContent />
            </div>
        </ZyNodeViewWrapper>
    );
}
